$('.arrows-container i.right').on('click', function() {
    var MovedActiveCount = $('.article-container .single.left').length
    var SingleActiveCount = $('.article-container .single').length
    var marginLeft = -(MovedActiveCount+1)*25;

    console.log(MovedActiveCount);
    console.log(SingleActiveCount);

    var RemoveRightArrow = SingleActiveCount - MovedActiveCount;

    if(RemoveRightArrow > 4) {
        $('.article-container').find('.notmoved').first().addClass('left');
        $('.article-container').find('.notmoved').first().removeClass('notmoved');
        $('.article-container').children().first('.single').css('margin-left',marginLeft+"%");
    }
    if(RemoveRightArrow <= 5) {
        $('.arrows-container i.right').removeClass('active');
    }
    $('.arrows-container i.left').addClass('active');
});

$('.arrows-container i.left').on('click', function() {
    var MovedActiveCount = $('.article-container .single.left').length
    var SingleActiveCount = $('.article-container .single').length
    var marginLeft = -(MovedActiveCount-1)*25;

    var RemoveRightArrow = SingleActiveCount - MovedActiveCount;

    if(MovedActiveCount == 1) {
        $('.arrows-container i.left').removeClass('active');
    }
    if(MovedActiveCount == 0) {
    }
    else {
        $('.article-container').find('.left').first().addClass('notmoved');
        $('.article-container').find('.left').first().removeClass('left');
        $('.article-container').children().first('.single').css('margin-left',marginLeft+"%");
    }
    $('.arrows-container i.right').addClass('active');
});